module.exports = __webpack_public_path__ + "static/img/cb.262b433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/website/cb.png
// module id = Lcg4
// module chunks = 1